import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../assets/vending-rebates-logo-high-res.png';

// Styled Components based on Header.css and Style Guide
const AppHeader = styled.header`
  background-color: #133B5C; /* Navy Blue */
  padding: 25px 40px; /* Increased vertical padding from 20px to 25px */
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px 20px; /* Adjusted padding for smaller screens */
  }
`;

const Logo = styled.img`
  height: 70px; /* Increased from 60px */
  width: auto;
  flex-shrink: 0;

  @media (max-width: 768px) {
    margin-bottom: 15px; /* Adjusted margin */
  }
  @media (max-width: 480px) {
    height: 60px; /* Increased from 50px */
  }
`;

const MainNav = styled.nav`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
  }

  li {
    margin: 0 25px; /* Increased spacing between nav items */
  }

  a {
    color: #F9F6F1; /* Off-White */
    text-decoration: none;
    font-family: 'Oswald', sans-serif;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 1.1em; /* Increased from 1em */
  }

  a:hover {
    color: #999589; /* Warm Gray for hover */
  }

  @media (max-width: 768px) {
    position: static;
    transform: none;
    width: 100%;
    margin: 20px 0; /* Adjusted margin for stacked layout */
    order: 1;
    display: flex;
    justify-content: center;

    ul {
      justify-content: center;
    }
  }

  @media (max-width: 480px) {
    a {
      font-size: 1em; /* Increased from 0.9em */
    }
  }
`;

const Tagline = styled.span`
  font-family: 'Oswald', 'Arial Black', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  color: #2A7131; /* Forest Green */
  font-size: 1.2em;
  white-space: nowrap;
  text-align: right;
  flex-shrink: 0;

  @media (max-width: 768px) {
    margin-top: 10px;
    text-align: center;
  }
  @media (max-width: 480px) {
    font-size: 1em;
  }
`;

const Header: React.FC = () => {
  return (
    <AppHeader>
      <Logo src={logo} alt="Vending Rebates Logo" />
      <MainNav>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/contact">Contact Us</Link>
          </li>
          <li>
            <Link to="/faqs">FAQs</Link>
          </li>
        </ul>
      </MainNav>
      <Tagline>SIMPLIFIED REBATE REGISTRATION</Tagline>
    </AppHeader>
  );
};

export default Header; 